import React from 'react';
import { motion } from 'framer-motion';
import { XIcon, CheckIcon, DumbbellIcon, FlagIcon } from 'lucide-react';
export function TotalPackDetails() {
  return <section className="py-24 px-4 bg-brand-dark border-t border-gray-800" data-id="element-299">
      <div className="max-w-4xl mx-auto" data-id="element-300">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-301">
          <h2 className="text-3xl md:text-5xl text-white font-display mb-4" data-id="element-302">
            ¿QUÉ AGREGA EL <span className="text-brand-pink" data-id="element-303">PACK TOTAL?</span>
          </h2>
          <p className="text-xl text-gray-400" data-id="element-304">
            Para las que quieren llegar a la línea de largada con fuerza real y
            cero dudas
          </p>
        </motion.div>

        <div className="space-y-8 mb-16" data-id="element-305">
          {/* Tomo 4 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-brand-black rounded-2xl p-6 md:p-8 border border-gray-800" data-id="element-306">
            <div className="flex items-center gap-4 mb-6" data-id="element-307">
              <div className="text-brand-copper font-display text-xl opacity-50" data-id="element-308">
                01 / 02
              </div>
              <h3 className="text-2xl text-white font-bold" data-id="element-309">
                Fuerza de Verdad — Tomo 4
              </h3>
            </div>
            <p className="text-brand-pink font-semibold mb-6" data-id="element-310">
              Llegás a HYROX sin fuerza funcional real
            </p>

            <div className="grid md:grid-cols-2 gap-6" data-id="element-311">
              <div className="bg-gray-900/50 p-5 rounded-xl border border-gray-800" data-id="element-312">
                <div className="flex items-center gap-2 text-gray-500 font-bold text-sm uppercase mb-3" data-id="element-313">
                  <XIcon className="w-4 h-4" data-id="element-314" /> Sin Pack Total
                </div>
                <p className="text-gray-400 text-sm leading-relaxed" data-id="element-315">
                  Hacés cardio y algo de fuerza básica pero en las estaciones de
                  empuje, tirón y carga tu cuerpo no responde.
                </p>
              </div>
              <div className="bg-brand-pink/5 p-5 rounded-xl border border-brand-pink/20" data-id="element-316">
                <div className="flex items-center gap-2 text-brand-pink font-bold text-sm uppercase mb-3" data-id="element-317">
                  <CheckIcon className="w-4 h-4" data-id="element-318" /> Con Pack Total
                </div>
                <p className="text-white text-sm leading-relaxed" data-id="element-319">
                  Sistema completo de fuerza funcional de 4 semanas. Más
                  potencia, más control, más seguridad en cada estación de
                  HYROX.
                </p>
              </div>
            </div>
          </motion.div>

          {/* Tomo 5 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-brand-black rounded-2xl p-6 md:p-8 border border-gray-800" data-id="element-320">
            <div className="flex items-center gap-4 mb-6" data-id="element-321">
              <div className="text-brand-copper font-display text-xl opacity-50" data-id="element-322">
                02 / 02
              </div>
              <h3 className="text-2xl text-white font-bold" data-id="element-323">
                Tu Primera Carrera — Tomo 5
              </h3>
            </div>
            <p className="text-brand-pink font-semibold mb-6" data-id="element-324">
              No sabés cómo prepararte para la carrera real
            </p>

            <div className="grid md:grid-cols-2 gap-6" data-id="element-325">
              <div className="bg-gray-900/50 p-5 rounded-xl border border-gray-800" data-id="element-326">
                <div className="flex items-center gap-2 text-gray-500 font-bold text-sm uppercase mb-3" data-id="element-327">
                  <XIcon className="w-4 h-4" data-id="element-328" /> Sin Pack Total
                </div>
                <p className="text-gray-400 text-sm leading-relaxed" data-id="element-329">
                  Tenés ganas de anotarte pero no sabés cómo funciona la
                  carrera, cómo inscribirte ni cómo llegar sin pánico el día D.
                </p>
              </div>
              <div className="bg-brand-pink/5 p-5 rounded-xl border border-brand-pink/20" data-id="element-330">
                <div className="flex items-center gap-2 text-brand-pink font-bold text-sm uppercase mb-3" data-id="element-331">
                  <CheckIcon className="w-4 h-4" data-id="element-332" /> Con Pack Total
                </div>
                <p className="text-white text-sm leading-relaxed" data-id="element-333">
                  Manual completo de 30 páginas con todo lo que necesitás saber
                  para inscribirte, prepararte y cruzar la meta con confianza.
                </p>
              </div>
            </div>
          </motion.div>
        </div>

        <div className="bg-gradient-to-r from-brand-dark to-brand-black p-8 rounded-2xl border border-brand-copper/30 text-center" data-id="element-334">
          <h4 className="text-brand-copper font-bold uppercase tracking-widest mb-6" data-id="element-335">
            EL PACK TOTAL INCLUYE:
          </h4>
          <div className="grid md:grid-cols-2 gap-6 text-left" data-id="element-336">
            <div className="flex gap-4" data-id="element-337">
              <DumbbellIcon className="w-8 h-8 text-brand-pink flex-shrink-0" data-id="element-338" />
              <div data-id="element-339">
                <div className="text-white font-bold mb-1" data-id="element-340">
                  T4 Fuerza de Verdad
                </div>
                <p className="text-sm text-gray-400" data-id="element-341">
                  Programa de fuerza funcional de 4 semanas para dominar las
                  estaciones de HYROX con potencia, técnica y confianza.
                </p>
              </div>
            </div>
            <div className="flex gap-4" data-id="element-342">
              <FlagIcon className="w-8 h-8 text-brand-pink flex-shrink-0" data-id="element-343" />
              <div data-id="element-344">
                <div className="text-white font-bold mb-1" data-id="element-345">
                  T5 Tu Primera Carrera
                </div>
                <p className="text-sm text-gray-400" data-id="element-346">
                  Guía completa de inscripción, preparación y estrategia para
                  vivir tu primera experiencia HYROX sin pánico y con claridad
                  total.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}